import { ArrowUpRight } from "lucide-react";
import { FadeUp, SectionHeading } from "@/components/Reveal";
import { PORTFOLIO } from "@/data/site";

const Portfolio = () => (
  <section id="portfolio" className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-12 lg:py-32" data-testid="portfolio-section">
    <SectionHeading
      eyebrow="Selected work"
      title="Launches we're proud of."
      sub="Real builds, real metrics. A snapshot of recent websites, apps and growth engines shipped by the Spark Plug team."
    />
    <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {PORTFOLIO.map((p, i) => (
        <FadeUp key={p.id} delay={i * 0.1}>
          <article
            className="group overflow-hidden rounded-2xl border border-white/10 bg-[#131316] transition-colors duration-300 hover:border-[#D9A92E]/50"
            data-testid={`portfolio-card-${p.id}`}
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={p.image}
                alt={p.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#131316] via-transparent to-transparent" />
              <span className="mono absolute left-4 top-4 rounded-full bg-[#09090B]/80 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-[#E9C766] backdrop-blur-sm">
                {p.category}
              </span>
            </div>
            <div className="p-6">
              <div className="flex items-start justify-between gap-3">
                <h3 className="text-lg font-semibold text-white">{p.title}</h3>
                <ArrowUpRight className="h-5 w-5 shrink-0 text-[#6B7280] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#D9A92E]" />
              </div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-display text-2xl font-extrabold text-[#D9A92E]">{p.metric}</span>
                <span className="text-xs text-[#6B7280]">{p.metricLabel}</span>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {p.tags.map((t) => (
                  <span key={t} className="mono rounded-full border border-white/10 px-2.5 py-1 text-[10px] uppercase tracking-wider text-[#A1A1AA]">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </article>
        </FadeUp>
      ))}
    </div>
  </section>
);

export default Portfolio;
